import { adapter, initialState, State } from './rule.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  AddInvoiceRuleComplete,
  AddInvoiceRuleConditionComplete,
  AddInvoiceRulesComplete,
  ArchiveInvoiceRuleComplete,
  DeleteInvoiceRuleComplete,
  DeleteInvoiceRuleConditionComplete,
  DeleteInvoiceRulesComplete,
  LoadInvoiceRulesComplete,
  PauseInvoiceRuleComplete,
  PauseInvoiceRuleReminderComplete,
  ResumeInvoiceRuleComplete,
  ResumeInvoiceRuleReminderComplete,
  UnArchiveInvoiceRuleComplete,
  UpdateInvoiceRuleComplete,
  UpdateInvoiceRuleConditionComplete,
} from './rule.actions'
import { RuleCondition } from './rule.model'
import * as R from 'ramda'
import { updateOne } from '@tokeet-frontend/utility'

export const reducer = createReducer(
  initialState,
  on(LoadInvoiceRulesComplete, (state, { rules }) => adapter.addAll(rules, { ...state, isLoaded: true })),
  on(AddInvoiceRuleComplete, (state, { rule }) => adapter.addOne(rule, state)),
  on(AddInvoiceRulesComplete, (state, { rules }) => adapter.addMany(rules, state)),
  on(UpdateInvoiceRuleComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(DeleteInvoiceRulesComplete, (state, { ids }) => adapter.removeMany(ids, state)),
  on(DeleteInvoiceRuleComplete, (state, { id }) => adapter.removeOne(id, state)),
  on(PauseInvoiceRuleComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(ResumeInvoiceRuleComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(ArchiveInvoiceRuleComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(UnArchiveInvoiceRuleComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(PauseInvoiceRuleReminderComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(ResumeInvoiceRuleReminderComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(UpdateInvoiceRuleConditionComplete, (state, { response }) => {
    const conditionsWithoutCurrent = R.filter(
      (k) => k.key !== response.condition.key,
      state.entities[response.ruleId].conditions
    )

    return adapter.updateOne(
      {
        id: response.ruleId,
        changes: {
          conditions: <any>R.append(response.condition, <RuleCondition[]>conditionsWithoutCurrent),
        },
      },
      state
    )
  }),
  on(AddInvoiceRuleConditionComplete, (state, { response }) =>
    adapter.updateOne(
      {
        id: response.ruleId,
        changes: {
          conditions: <any>R.append(response.condition, <RuleCondition[]>state.entities[response.ruleId].conditions),
        },
      },
      state
    )
  ),
  on(DeleteInvoiceRuleConditionComplete, (state, { response }) =>
    adapter.updateOne(
      {
        id: response.ruleId,
        changes: {
          conditions: <any>R.filter((k) => k.key !== response.conditionId, state.entities[response.ruleId].conditions),
        },
      },
      state
    )
  )
)

export function invoiceRuleReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
